import { render, staticRenderFns } from "./MessageBanner.vue?vue&type=template&id=3bc6f0b9"
import script from "./MessageBanner.ts?vue&type=script&lang=ts&external"
export * from "./MessageBanner.ts?vue&type=script&lang=ts&external"
import style0 from "./MessageBanner.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports